import { Page } from "../../models/page.model";
import { Sitemap } from "../../models/sitemap.model";

export const userPage = new Page("1234");
export const siteMap = new Sitemap("1234");
